import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ChangeAddressModalNames } from "rtr-constants";
import { displayModal } from "actions/shared-actions";
import ChangeShippingAddress from "components/source/shared/shipping_addresses/ChangeShippingAddress.jsx";
import MembershipHelper from "helpers/membership-helpers";

const propTypes = {
  membershipState: PropTypes.object,
  openChangeDefaultAddressModal: PropTypes.func,
};

class MembershipShippingAddress extends React.Component {
  constructor(props) {
    super(props);
  }

  static get MOBILE_CHAR_LIMIT() {
    return 26;
  }

  handleClick = () => {
    this.props.openChangeDefaultAddressModal();
  };

  shipmentAddress() {
    return this.props.membershipState?.address;
  }

  getStreet() {
    const address = this.shipmentAddress();
    if (address) {
      return address.street1;
    }
  }

  renderProcessedStreet() {
    const street = this.getStreet();
    const streetLength = "street"?.length ?? 0;
    const mobileCharLimit = this.constructor.MOBILE_CHAR_LIMIT;

    if (streetLength > mobileCharLimit) {
      return street.slice(0, mobileCharLimit - 3) + "...";
    } else {
      return street;
    }
  }

  render() {
    if (_.isEmpty(this.renderProcessedStreet())) return null;
    return (
      // We're using a fragment so the changeShippingAddress modal can be rendered outside the p tag.
      // We're preventing the click event from propagating into membership-shipping-address
      <>
        <button className="membership-shipping-address" onClick={this.handleClick} type="button">
          Delivering to{" "}
          <span className="membership-shipping-address__street universal-underline">
            {this.renderProcessedStreet()}
          </span>
        </button>
        <ChangeShippingAddress
          addressBookTitle="Where will we be shipping?"
          addressBookDek="We'll show you available styles in that location."
          modalName={ChangeAddressModalNames.changeAddressFromMembershipFormFields}
        />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    membershipState: MembershipHelper.getMembershipState(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch,
    openChangeDefaultAddressModal: () => {
      dispatch(displayModal(ChangeAddressModalNames.changeAddressFromMembershipFormFields));
    },
  };
};

MembershipShippingAddress.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(MembershipShippingAddress);
